import { object, string } from 'yup';
const forgotPasswordValidation = object().shape({
  email: string().email('validations.email.format').required('validations.email.required')
});
export default forgotPasswordValidation;